<div class="downloads" *ngIf="block.content">
    <ul class="downloads__list">
        <li class="downloads__list-item" *ngFor="let block of block.content trackBy: trackByFn;">
            <a *ngIf="block.data.file || block.data.url" class="downloads__list-link" href="{{block.data.file && block.data.file.id ? api + '/download/' + block.data.file.id : block.data.url}}" target="{{block.data.target}}">
                <span *ngIf="block.data.text || block.data.file.name" class="downloads__list-text">{{block.data.text || block.data.file.name}}</span>
            </a>
        </li>
    </ul>
</div>
